import { render, staticRenderFns } from "./LabelAim.vue?vue&type=template&id=35e8b2cc&scoped=true&"
import script from "./LabelAim.vue?vue&type=script&lang=js&"
export * from "./LabelAim.vue?vue&type=script&lang=js&"
import style0 from "./LabelAim.scss?vue&type=style&index=0&id=35e8b2cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8b2cc",
  null
  
)

export default component.exports